import { IDirectoryState } from './directory.state';
import externalDirectoryReducer from './externalDirectory/reducers';
import { IExternalDirectoryActions } from './externalDirectory/actions';
import { DirectoryAction } from './directory.actions';
import directorySearchParamsReducer from './searchParams/reducer';
import teamsReducer from './teams/reducers';
import { SearchParamAction } from './searchParams/actions';
import { OwnersAction } from './owners/actions';
import ownersReducer from './owners/reducers';
import { TeamsAction } from './teams/actions';
import restructuredDirectoryContactsReducer from './restructuredContactsByPhoneNumber/reducers';
import { IRestructuredContactsByPhoneNumberActions } from './restructuredContactsByPhoneNumber/actions';

const defaultState: IDirectoryState = {
    owners: {
        data: [],
        getOwnersLoading: false,
    },
    teams: {
        contacts: [],
        contactsStatuses: {},
        isTeamsContactsLoading: undefined,
        isTeamsStatusesLoading: undefined,
        errors: [],
    },
    externalDirectory: {
        contacts: [],
        isLoading: undefined,
        editContactLoading: false,
        deleteContactLoading: false,
        errors: [],
        manageExternalDirectorySearchParams: {},
    },
    searchParams: {
        priority: undefined,
        owner: undefined,
        search: undefined,
    },
    restructuredDirectoryContacts: {
        contactsWithKeyAsPhoneNumber: {},
        isProcessing: undefined,
    },
};

export default (
    state: IDirectoryState = defaultState,
    action: DirectoryAction
) => {
    return {
        externalDirectory: externalDirectoryReducer(
            state.externalDirectory,
            action as IExternalDirectoryActions
        ),
        teams: teamsReducer(state.teams, action as TeamsAction),
        owners: ownersReducer(state.owners, action as OwnersAction),
        searchParams: directorySearchParamsReducer(
            state.searchParams,
            action as SearchParamAction
        ),
        restructuredDirectoryContacts: restructuredDirectoryContactsReducer(
            state.restructuredDirectoryContacts,
            action as IRestructuredContactsByPhoneNumberActions
        ),
    };
};
